import '../../style/';
import './index.less';
import '../../badge/style/';



/** WEBPACK FOOTER **
 ** ./components/tab-bar/style/index.web.tsx
 **/